<template>
    <div>
      <div class="mb-4 flex justify-content-between align-items-center">
        <span class="pr-2 mr-2 font-bold text-2xl">Print Price Card</span>
        <div>
          <i class="pi pi-home mr-2"></i>
          <span class="font-small">/ Inventory / Print Price Card</span>
        </div>
      </div>
      <div class="card bg-white">
        <div class="flex justify-content-end mb-2">
          <Button
            type="button"
            icon="pi pi-print"
            label="Print"
            class="mr-2"
            :loading="isLoadingPrint"
            @click="generateBarcode()"
          />
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            :disabled="active === 0"
            class="p-button-secondary mr-2"
            @click="save()"
          />
          <Button
            type="button"
            icon="pi pi-file-import"
            label="Upload"
            class="p-button-green mr-2"
            v-if="active === 1"
            @click="uploadCSV"
          />
          <Button
            type="button"
            icon="pi pi-refresh"
            label="Refresh"
            class="p-button-outlined"
            @click="clearFilter()"
          />
        </div>
        <TabView v-model:activeIndex="active" @tab-change="onTabChange()">
          <TabPanel header="Label Barcode dari Penerimaan">
            <div class="col-12">
              <div class="formgrid grid">
                <div class="field col-12 md:col-2">
                  <label>No. Penerimaan</label>
                  <AutoComplete
                    v-model="selectedReceive"
                    class="w-full"
                    input-class="w-full"
                    :suggestions="listReceive"
                    field="rcv_no"
                    v-on:clear="true"
                    @complete="searchReceive"
                    @item-select="selectReceive"
                    @keyup.enter="onReceiveEnter"
                  >
                    <template #item="slotProps">
                      <div>
                        <b>{{ slotProps.item.rcv_no }}</b>
                      </div>
                      <div>
                        {{ formatDate(slotProps.item.rcv_at) }} |
                        {{ slotProps.item.supplier.name }}
                      </div>
                    </template>
                  </AutoComplete>
                </div>
                <div class="field col-12 md:col-3">
                  <label> &nbsp; </label>
                  <InputText
                    v-model="form.supplier"
                    class="w-full"
                    disabled
                    input-class="w-full"
                  />
                </div>
                <div class="field col-12 md:col-4 mt-5">
                  <input
                    ref="changeCheckbox"
                    :checked="change"
                    type="checkbox"
                    @click="onChecked"
                    @keyup.enter="onChangeCheckboxEnter"
                  /><label>Hanya Item dengan Perubahan Harga</label>
                </div>
                <div class="field col-12 md:col-3 mt-4">
                  <Button
                    ref="loadButton"
                    icon="pi pi-sync"
                    label="Load Data Penerimaan"
                    class="mr-2"
                    :disabled="!(form.id > 0)"
                    @click="loadItem"
                  />
                </div>
              </div>
            </div>
            <div class="card">
              <fx-table
                :items="items"
                :total="items.length"
                :loading="isLoading"
                :paginator="false"
                hasFooter
                showGridlines
              >
                <template #columns>
                  <Column
                    field="rcv_at"
                    header="Tgl. RCV"
                    :showFilterMenu="false"
                    style="min-width: 6rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ formatDate(data.rcv_at) }}
                    </template>
                  </Column>
                  <Column
                    field="description"
                    header="Deskripsi"
                    class="bg-gray"
                    style="min-width: 15rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="unit_b"
                    header="Satuan"
                    class="bg-gray"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ data.unit_b }}.{{ data.unit_s }}
                    </template>
                  </Column>
                  <Column
                    field="ubox"
                    header="Isi"
                    class="bg-gray"
                    style="width: 2rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="qty_rcv"
                    header="Qty.&nbsp; RCV"
                    class="bg-gray"
                    style="min-width: 5rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="qty_stock"
                    header="Stock Qty"
                    class="bg-gray"
                    style="min-width: 5rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="cur_price"
                    header="HRG Jual SKRG"
                    class="bg-gray"
                    style="min-width: 8rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ formatCurrency(data.cur_price) }}
                    </template>
                  </Column>
                  <Column
                    field="new_price"
                    header="HRG Jual Baru"
                    class="bg-gray"
                    style="min-width: 8rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ formatCurrency(data.new_price) }}
                    </template>
                  </Column>
                  <Column
                    field="qty_label"
                    header="Qty. Label"
                    class="bg-gray"
                    style="min-width: 1rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      <InputNumber
                        v-model="data.qty_label"
                        type="text"
                        class="w-full"
                        input-class="w-full"
                      />
                    </template>
                  </Column>
                  <Column
                    field="description_tag"
                    header="Keterangan"
                    class="bg-gray"
                    style="min-width: 18rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      <InputText
                        v-model="data.description_tag"
                        type="text"
                        class="w-full"
                        input-class="w-full"
                        maxlength="50"
                      />
                    </template>
                  </Column>
                </template>
              </fx-table>
            </div>
          </TabPanel>
          <TabPanel header="Label Barcode Manual">
            <div class="col-12">
              <div class="formgrid grid">
                <div class="field col-12 md:col-3">
                  <label>Item</label>
                  <AutoComplete
                    ref="itemAutocomplete"
                    v-model="selectedItem"
                    class="w-full"
                    input-class="w-full"
                    :suggestions="listItems"
                    field="name"
                    @complete="searchItem"
                    @item-select="selectItem"
                    @keyup.enter="onItemEnter"
                  >
                    <template #item="slotProps">
                      <div>
                        <b>{{ slotProps.item.sku }}</b>
                      </div>
                      <div>{{ slotProps.item.name }}</div>
                    </template>
                  </AutoComplete>
                </div>
                <div class="field col-12 md:col-3">
                  <label> Supplier </label>
                  <AutoComplete
                    ref="supplier"
                    v-model="selectedSupplier"
                    class="w-full"
                    input-class="w-full"
                    placeholder="Search"
                    :suggestions="listSupplier"
                    field="name"
                    @complete="searchSupplier"
                    @item-select="onSelectSupplier"
                    @keyup.enter="onSupplierEnter"
                  >
                  </AutoComplete>
                </div>
                <div class="field col-12 md:col-2 mt-4">
                  <Button
                    ref="addButton"
                    icon="pi pi-plus"
                    label="Tambah Item"
                    class="w-full"
                    @click="onAddData"
                  />
                </div>
                <div class="field col-12 md:col-2 mt-4">
                  <Button
                    icon="pi pi-times-circle"
                    label="Clear All"
                    class="p-button-outlined"
                    @click="onReset"
                  />
                </div>
              </div>
            </div>
            <div class="card">
              <fx-table
                :items="itemManuals"
                :total="itemManuals.length"
                :loading="isLoading"
                :paginator="false"
                hasFooter
                showGridlines
              >
                <template #columns>
                  <Column
                    field="sku"
                    header="Kode"
                    class="bg-gray"
                    style="min-width: 3rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="barcode_1"
                    header="Barcode"
                    class="bg-gray"
                    style="min-width: 8rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="description"
                    header="Deskripsi"
                    class="bg-gray"
                    style="min-width: 18rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      <InputText
                        v-model="data.description"
                        type="text"
                        class="w-full"
                        input-class="w-full"
                        maxlength="50"
                      />
                    </template>
                  </Column>
                  <Column
                    field="unit"
                    header="Satuan"
                    class="bg-gray"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ data.unit_b }}.{{ data.unit_s }}
                    </template>
                  </Column>
                  <Column
                    field="ubox"
                    header="Isi"
                    class="bg-gray"
                    style="width: 2rem"
                    header-style="align-items: end"
                  />
                  <Column
                    field="qty_label"
                    header="Qty. Print"
                    class="bg-gray"
                    style="min-width: 3rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      <InputNumber
                        v-model="data.qty_label"
                        type="text"
                        class="w-full"
                        input-class="w-full"
                      />
                    </template>
                  </Column>
                  <Column
                    field="price"
                    header="Harga"
                    class="bg-gray"
                    style="min-width: 8rem"
                    header-style="align-items: end"
                  >
                    <template #body="{ data }">
                      {{ formatCurrency(data.price) }}
                    </template>
                  </Column>
                  <Column
                    field="supplier"
                    header="Supplier"
                    class="bg-gray"
                    style="min-width: 12rem"
                    header-style="align-items: end"
                    :hidden="!showSupplierColumn"
                  >
                  </Column>               
                  <Column style="flex-grow: 1; justify-content: flex-end">
                    <template #body="{ data }">
                      <Button
                        type="button"
                        icon="pi pi-trash"
                        class="p-button-outlined p-button-danger p-button-text"
                        @click="onConfirmDeletion(data)"
                      />
                    </template>
                  </Column>
                </template>
              </fx-table>
            </div>
          </TabPanel>
        </TabView>
      </div>
      <Dialog
        header="Hapus Item dari List"
        v-model:visible="dialogHapus"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '50vw' }"
        :modal="true"
      >
        <div class="confirmation-content">
          <span
            >Item <strong>{{ formManual.description }}</strong> akan dihapus dari
            List Item Barcode. Proses ?</span
          >
        </div>
        <template #footer>
          <Button
            label="Hapus"
            icon="pi pi-trash"
            @click="onDeleteItem(this.rowdata)"
            class="p-button-text p-button-danger"
          />
        </template>
      </Dialog>
      <Dialog
        header="Import Data Barcode Manual"
        v-model:visible="dialogImport"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '55vw' }"
        :modal="true"
      >
        <div class="confirmation-content">
          <div class="formgrid grid mb-3">
            <div class="field col-12 md:col-6">
              <label>Supplier (berlaku untuk semua item yang diimport)</label>
              <AutoComplete
                v-model="selectedSupplierImport"
                class="w-full"
                input-class="w-full"
                placeholder="Search"
                :suggestions="listSupplier"
                field="name"
                @complete="searchSupplier"
              />
            </div>
            <div class="field col-12 md:col-6">
              <label class="w-full">File (.csv / .xlsx)</label>
              <input
                type="file"
                id="inputBarcode"
                ref="doc"
                @change="readFile()"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
          </div>
          <small class="p-error">{{ strFile }}</small>
          <div class="card">
            <fx-table
              :items="csv_itemaddnew"
              :total="csv_itemaddnew.length"
              :loading="isLoadingImport"
              :paginator="false"
              row-class="rowClassImport"
              showGridlines
              showRowClass
            >
              <template #columns>
                <Column
                  field="barcode"
                  header="Barcode"
                  style="width: 50%"
                >
                  <template #body="{ data }">
                    {{ data.barcode }}
                    <Button
                      v-if="data.mark === 1"
                      type="button"
                      v-tooltip="'Barcode tidak ditemukan di master item'"
                      icon="pi pi-exclamation-triangle"
                      class="p-button-danger p-button-text mr-2"
                    />
                  </template>
                </Column>
                <Column
                  field="qty_op"
                  header="Qty"
                  style="width: 50%; justify-content: flex-start"
                />
              </template>
            </fx-table>
          </div>

        </div>
        <template #footer>
          <Button
            label="OK"
            :loading="isLoadingImport"
            :disabled="csv_itemaddnew.length === 0"
            @click="onLoadCSV()"
            class="p-button p-button-primary"
          />
          <Button
            label="Cancel"
            @click="onCancel()"
            class="p-button p-button-primary"
          />
        </template>
      </Dialog>
      <Dialog
        :header="pdfTitle"
        v-model:visible="dialogViewer"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '90vw' }"
        :modal="true"
      >
        <div>
          <embed
            :src="pdfSource"
            type="application/pdf"
            width="100%"
            height="600px"
          />
        </div>
        <template #footer>
          <Button
            type="button"
            label="Download"
            icon="pi pi-download"
            class="p-button-text mr-2"
            @click="onDownloadPdf"
          />
          <Button
            type="button"
            label="Print"
            icon="pi pi-print"
            @click="onPrintPdf"
          />
        </template>
      </Dialog>
      <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
    </div>
  </template>
  
  <script>
  import SupplierService from '@/services/SupplierService'
  import BarcodeService from '@/services/BarcodeService'
  import errorHandler from '@/helpers/error-handler'
  import Hotkey from '@/components/Hotkey'
  import { formatCurrency, formatDate } from '@/helpers/index'
  import TabView from 'primevue/tabview'
  import TabPanel from 'primevue/tabpanel'
  
  import FxTable from '@/components/FxTable'
  import { useAuthStore } from '@/store/auth'
  
  import { jsPDF } from 'jspdf'
  import { saveAs } from 'file-saver'
  import ItemService from '@/services/ItemService'
  import readXlsxFile from 'read-excel-file'
  
  export default {
    name: 'PrintBarcode',
    components: {
      Hotkey,
      TabView,
      TabPanel,
      FxTable,
    },
    data() {
      return {
        index: 0,
        rowdata: {},
        isLoading: false,
        isLoadingSave: false,
        isLoadingPrint: false,
        barcodeService: null,
        listReceive: [],
        selectedReceive: null,
        selectedSupplier: null,
        form: {},
        formManual: {},
        items: [],
        itemManuals: [],
        itemService: null,
        supplierService: null,
        listItems: [],
        listSupplier: [],
        submitted: false,
        selectedItem: [],
        listDeleted: [],
        active: 0,
        change: false,
        totalRecords: 0,
        options: {
          page: 1,
          rows: 10,
          sortField: '',
          sortOrder: '1',
          filters: null,
        },
        pdfSource: '',
        pdfFilename: '',
        pdfTitle: 'PDF Viewer ',
        dialogViewer: false,
        dialogHapus: false,
        dialogImport: false,
        isLoadingImport: false,
        csv_itemaddnew: [],
        file: null,
        strFile: '',
        content: null,
        breakLines: '-',
        selectedSupplierImport: null,
        showSupplierColumn: true,
      }
    },
    created() {
      this.supplierService = new SupplierService()
      this.barcodeService = new BarcodeService()
      this.itemService = new ItemService()
    },
    mounted() {
  
      if ('rcvid' in localStorage) {
        this.change = true
        this.form.id = localStorage.getItem(`rcvid`)
        this.loadItem()
      }
      
    },
    methods: {
      onReceiveEnter() {
        this.$nextTick(() => {
          setTimeout(() => {
            const el = this.$refs.changeCheckbox
            if (el) el.focus()
          }, 0)
        })
      },
      onChangeCheckboxEnter() {
        this.$nextTick(() => {
          const btn = this.$refs.loadButton?.$el
          if (btn) btn.focus()
        })
      },
      onItemEnter() {
        this.$nextTick(() => {
          const input = this.$refs.supplier?.$el?.querySelector('input')
          if (input) {
            input.focus()
            input.setSelectionRange(input.value.length, input.value.length)
          }
        })
      },
      onSupplierEnter() {
        this.$nextTick(() => {
          const btn = this.$refs.addButton?.$el
          if (btn) btn.focus()
        })
      },
      generateBarcode() {
        this.isLoadingPrint = true
        setTimeout(() => {
          if (this.active == 0) {
            this.generateBarCodebyRcv()
          } else {
            this.generateBarCodeManual()
          }
  
          this.isLoadingPrint = false // Reset loading state after the process is done
        }, 100)
        // if (this.active == 0) {
        //   this.generateBarCodebyRcv()
        // } else {
        //   this.generateBarCodeManual()
        // }
      },
      generateBarCodebyRcv() {
        if (this.items.length == 0) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail: 'Pilih dan load data penerimaan terlebih dahulu.',
            life: 3000,
          })
          return
        }
  
        if (this.isLoadingPrint === true) {
            // Ukuran kertas A4 portrait dalam mm
            const doc = new jsPDF('p', 'mm', 'a4')

            // Ukuran label
            const labelW = 65   // 6.5cm
            const labelH = 33   // 3.3cm
            const gap    = 2    // jarak antar kotak 2mm

            // Layout grid
            const cols = 3      // 3 kolom (3 x 65mm = 195mm, sisa 15mm margin)
            const rows = 8      // 9 baris (9 x 33mm = 297mm, pas A4)

            // Total lebar 3 label + 2 gap = (3*65) + (2*2) = 195 + 4 = 199mm
            // Margin kiri: (210 - 199) / 2 = 11mm
            const marginLeft = 5.5
            const marginTop  = 5.5

            let itemTotal = 0
            let itemIndex = 0
            let labelCount = 0  // counter label di halaman saat ini

            this.items.forEach((item) => {
            itemTotal += item.qty_label
            })

            if (itemTotal > 1000) {
            this.$toast.add({
                severity: 'warn',
                summary: 'Barcode',
                detail: 'Jumlah label barcode melebihi batas cetak maksimal 1000 pcs',
                life: 3000,
            })
            return
            }

            this.items.forEach((item) => {
            for (let index = 0; index < item.qty_label; index++) {
                itemIndex += 1

                // Posisi kolom & baris — tambahkan gap di sini
                const col = labelCount % cols
                const row = Math.floor(labelCount / cols) % rows

                const x = marginLeft + col * (labelW + gap)
                const y = marginTop  + row * (labelH + gap)

                // Teks deskripsi (atas)
                doc.setFontSize(10)
                doc.setFont(undefined, 'normal')
                doc.text(item.description_tag, x + labelW / 2, y + 5, { 
                        align: 'center', 
                        maxWidth: labelW - 4  // maksimal 63mm (padding 2mm kiri-kanan)
                        })

                // Teks barcode & supplier
                doc.setFontSize(7)
                doc.setFont(undefined, 'normal')
                // SKU - rata kiri
                doc.text(item.sku, x + 2, y + 16, { align: 'left' })

                // Tanggal - rata tengah
                doc.text(new Date().toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-'), x + labelW / 2, y + 16, { align: 'center' })

                // Barcode - rata kanan
                doc.text(item.barcode_1, x + labelW - 2, y + 16, { align: 'right' })
                
                // Garis bawah
                doc.line(x, y + 18, x + labelW, y + 18)

                // Harga (bawah)
                doc.setFontSize(9)
                doc.setFont(undefined, 'normal')
                doc.text("Rp.", x + 2, y + 23, { align: 'left' })

                doc.setFontSize(18)
                doc.setFont(undefined, 'bold')
                doc.text(this.formatCurrency(item.new_price), x + labelW / 2, y + 29, { align: 'center' })

                // Border label
                doc.rect(x, y, labelW, labelH)

                labelCount += 1

                // Tambah halaman baru jika sudah penuh (27 label) dan masih ada item
                if (labelCount >= cols * rows && itemIndex < itemTotal) {
                doc.addPage()
                labelCount = 0
                }
            }
            })

            const pdfUrl = URL.createObjectURL(doc.output('blob'))
            this.pdfSource    = pdfUrl + '#toolbar=0'
            this.pdfFilename  = 'item-barcode-manual.pdf'
            this.pdfTitle     = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
            this.isLoadingPrint = false
        }
      },
      generateBarCodeManual() {
        if (this.itemManuals.length == 0) {
            this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail: 'Pilih item barcode terlebih dahulu.',
            life: 3000,
            })
            return
        }

        if (this.isLoadingPrint === true) {
            // Ukuran kertas A4 portrait dalam mm
            const doc = new jsPDF('p', 'mm', 'a4')

            // Ukuran label
            const labelW = 65   // 6.7cm
            const labelH = 33   // 3.3cm
            const gap    = 2    // jarak antar kotak 2mm

            // Layout grid
            const cols = 3      // 3 kolom (3 x 65mm = 201mm, sisa 9mm margin)
            const rows = 8      // 9 baris (9 x 33mm = 297mm, pas A4)
            
            // Total lebar 3 label + 2 gap = (3*65) + (2*2) = 195 + 4 = 199mm
            // Margin kiri: (210 - 199) / 2 = 11mm
            const marginLeft = 5.5
            const marginTop  = 5.5

            let itemTotal = 0
            let itemIndex = 0
            let labelCount = 0  // counter label di halaman saat ini

            this.itemManuals.forEach((item) => {
            itemTotal += item.qty_label
            })

            if (itemTotal > 1000) {
            this.$toast.add({
                severity: 'warn',
                summary: 'Barcode',
                detail: 'Jumlah label barcode melebihi batas cetak maksimal 1000 pcs',
                life: 3000,
            })
            return
            }

            this.itemManuals.forEach((item) => {
            for (let index = 0; index < item.qty_label; index++) {
                itemIndex += 1

                // Posisi kolom & baris — tambahkan gap di sini
                const col = labelCount % cols
                const row = Math.floor(labelCount / cols) % rows

                const x = marginLeft + col * (labelW + gap)
                const y = marginTop  + row * (labelH + gap)

                // Teks deskripsi (atas)
                doc.setFontSize(10)
                doc.setFont(undefined, 'normal')
                doc.text(item.description, x + labelW / 2, y + 5, { 
                        align: 'center', 
                        maxWidth: labelW - 4  // maksimal 63mm (padding 2mm kiri-kanan)
                        })

                // Teks barcode & supplier
                doc.setFontSize(7)
                doc.setFont(undefined, 'normal')
                // SKU - rata kiri
                doc.text(item.sku, x + 2, y + 16, { align: 'left' })

                // Tanggal - rata tengah
                doc.text(new Date().toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-'), x + labelW / 2, y + 16, { align: 'center' })

                // Barcode - rata kanan
                doc.text(item.barcode_1, x + labelW - 2, y + 16, { align: 'right' })
                
                // Garis bawah
                doc.line(x, y + 18, x + labelW, y + 18)

                // Harga (bawah)
                doc.setFontSize(9)
                doc.setFont(undefined, 'normal')
                doc.text("Rp.", x + 2, y + 23, { align: 'left' })

                doc.setFontSize(18)
                doc.setFont(undefined, 'bold')
                doc.text(this.formatCurrency(item.price), x + labelW / 2, y + 29, { align: 'center' })

                // Border label
                doc.rect(x, y, labelW, labelH)

                labelCount += 1

                // Tambah halaman baru jika sudah penuh (27 label) dan masih ada item
                if (labelCount >= cols * rows && itemIndex < itemTotal) {
                doc.addPage()
                labelCount = 0
                }
            }
            })

            const pdfUrl = URL.createObjectURL(doc.output('blob'))
            this.pdfSource    = pdfUrl + '#toolbar=0'
            this.pdfFilename  = 'item-barcode-manual.pdf'
            this.pdfTitle     = 'PDF Viewer (' + this.pdfFilename + ')'
            this.dialogViewer = true
            this.isLoadingPrint = false
        }
      },
      selectReceive() {
        this.form.id = this.selectedReceive.id
        this.form.rcv_at = this.selectedReceive.rcv_at
        this.form.rcv_no = this.selectedReceive.rcv_no
        this.form.supplier = this.selectedReceive.supplier.name
        this.onReceiveEnter()
      },
      searchReceive(event) {
        this.form = {}
        this.barcodeService
          .receive(event.query)
          .then((res) => {
            this.listReceive = res.data
          })
          .catch((err) => {
            errorHandler(err, 'Data Receive', this)
          })
          .finally(() => (this.isLoading = false))
      },
      searchSupplier(event) {
        const search = event.query
        this.supplierService
          .getList(search)
          .then((res) => {
            this.listSupplier = res.data
          })
          .catch((err) => {
            errorHandler(err, 'Data Supplier', this)
          })
          .finally(() => (this.isLoading = false))
      },
      onSelectSupplier() {
        if (this.selectedSupplier) {
          this.form.supp_id = this.selectedSupplier.id
          this.formManual.supplier = this.selectedSupplier.name
          this.formManual.supp = this.selectedSupplier.supp
        }
        this.onSupplierEnter()
      },
      formatDate(value) {
        return formatDate(value, false)
      },
      formatCurrency(value) {
        return formatCurrency(value, 0, 0)
      },
      onReset() {
        this.itemManuals.forEach((item) => {
          this.listDeleted.push(item.id)
        })
        this.itemManuals = []
      },
      clearFilter() {
        this.listReceive = []
        this.selectedReceive = null
        this.form = {}
        this.items = []
        this.formManual = {}
        this.selectedItem = null
  
        this.barcodeService
          .get()
          .then((res) => {
            this.itemManuals = res.data
          })
          .catch((err) => {
            errorHandler(err, 'Data Barcode', this)
          })
          .finally(() => (this.isLoading = false))
      },
      searchItem(event) {
        this.itemService
          .getList(event.query)
          .then((res) => {
            this.listItems = res.data
          })
          .catch((err) => {
            errorHandler(err, 'Data Item', this)
          })
          .finally(() => (this.isLoading = false))
      },
      selectItem() {
        this.formManual.id = 0
        this.formManual.item_id = this.selectedItem.id
        this.formManual.sku = this.selectedItem.sku
        this.formManual.barcode_1 = this.selectedItem.barcode_1
        this.formManual.description = this.selectedItem.name.substr(0, 50)
        this.formManual.ubox = this.selectedItem.ubox
        this.formManual.unit_s = this.selectedItem.unit_s
        this.formManual.unit_b = this.selectedItem.unit_b
        this.formManual.supp_id = this.selectedItem.supp_id
        this.formManual.price = this.selectedItem.price
        this.formManual.qty_label = 1

        this.supplierService
          .getById(`/${this.formManual.supp_id}`)
          .then((res) => {
            this.listSupplier = [res.data.data]
            this.selectedSupplier = res.data.data
          })
          .catch((err) => {
            errorHandler(err, 'Data Supplier', this)
          })
          .finally(() => {
            this.onItemEnter()   // fokus dipasang SETELAH API supplier selesai, bukan race dengannya
          })
      },
      onAddData() {
        if (this.formManual.item_id == null) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail: 'Pilih item terlebih dahulu.',
            life: 3000,
          })
          return
        }
  
        const idx = this.itemManuals.findIndex(
          (item) =>
            item.item_id === this.formManual.item_id &&
            item.supp_id === this.formManual.supp_id
        )
        if (idx !== -1) {
          const item = this.itemManuals[idx]
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail:
              'Item ' +
              item.description +
              ' dengan supplier ' +
              item.supplier +
              ' sudah ada di list.',
            life: 3000,
          })
          return
        }
        const idn = this.listSupplier.findIndex(
          (item) => item.id === this.formManual.supp_id
        )
        if (idn !== -1) {
          const supplier = this.listSupplier[idn]
          this.formManual.supplier = supplier.name
          this.formManual.supp = supplier.supp
        }
        
        this.itemManuals.push(this.formManual)
        this.showSupplierColumn = true
        this.formManual = {}
        this.selectedItem = null
        this.selectedSupplier = null
      },
      onConfirmDeletion(data) {
        this.index = data.index
        this.rowdata = data
        this.dialogHapus = true
      },
      onDeleteItem(data) {
        this.listDeleted.push(this.rowdata.id)
        this.itemManuals.splice(data.index, 1)
        // this.$toast.add({
        //   severity: 'success',
        //   summary: 'Data Item Barcode',
        //   detail: 'Data berhasil dihapus.',
        //   life: 3000,
        // })
        this.dialogHapus = false
      },
      save() {
        this.submitted = true
        // const deleted = this.id ? { deleted: this.listDeleted } : { deleted: [] }
        const auth = useAuthStore()
        const form = {
          username: auth.user.name,
          details: this.itemManuals.map((item) => {
            return {
              id: item.id,
              item_id: item.item_id,
              sku: item.sku,
              barcode_1: item.barcode_1,
              description: item.description,
              ubox: item.ubox,
              unit_s: item.unit_s,
              unit_b: item.unit_b,
              supp_id: item.supp_id,
              price: item.price,
              qty_label: item.qty_label,
              supp: item.supp,
              supplier: item.supplier,
            }
          }),
          deleted: this.listDeleted,
        }
        this.isLoadingSave = true
        this.barcodeService
          .save(form)
          .then((res) => {
            if (res.data.status === 1) {
              this.$toast.add({
                severity: 'success',
                summary: 'Barcode Item',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })
            }
          })
          .catch((err) => {
            errorHandler(err, 'Barcode Item', this)
          })
          .finally(() => {
            this.deleted = []
            this.isLoadingSave = false
          })
      },
      onTabChange() {
        if (this.active === 1) {
          // this.supplierService
          //   .getList()
          //   .then((res) => {
          //     this.listSupplier = res.data
          //   })
          //   .catch((err) => {
          //     errorHandler(err, 'Data Supplier', this)
          //   })
          //   .finally(() => (this.isLoading = false))
        }
      },
      onChecked() {
        this.change = !this.change
      },
      loadItem() { 
        this.isLoading = true 
        this.barcodeService 
            .receiveitem(this.form.id, this.change) 
            .then((res) => { 
            // Mengubah setiap item di dalam list agar qty_label bernilai default 1
            this.items = res.data.map(item => {
                return {
                ...item,
                qty_label: 1
                }
            })
            this.isLoading = false 
            }) 
            .catch((err) => { 
            errorHandler(err, 'Data Receive Item', this) 
            }) 
            .finally(() => (this.isLoading = false)) 
        },
      convertBase64ToImage(base64) {
        const image = new Image()
        image.src = base64
        return URL.createObjectURL(this.base64ToBlob(base64))
      },
      base64ToBlob(base64) {
        const byteString = atob(base64.split(',')[1])
        const mimeString = base64.split(',')[0].split(':')[1].split(';')[0]
        const ab = new ArrayBuffer(byteString.length)
        const ia = new Uint8Array(ab)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ab], { type: mimeString })
      },
      onDownloadPdf() {
        saveAs(this.pdfSource, this.pdfFilename)
      },
      onPrintPdf() {
        const iframe = document.createElement('iframe')
        iframe.src = this.pdfSource
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
  
        // Use onload to make pdf preview work on firefox
        iframe.onload = () => {
          iframe.contentWindow.focus()
          iframe.contentWindow.print()
        }
      },
      onTriggerHotkey(payload) {
        if (payload.keyString === 'D') {
          //
        }
      },
      onLoadingPrint() {
        setTimeout(() => {
          this.isLoadingPrint = true
        }, 500)
      },

      uploadCSV() {
        this.csv_itemaddnew = []
        this.strFile = ''
        this.selectedSupplierImport = null
        this.dialogImport = true
      },
      readFile() {
        this.csv_itemaddnew = []
        this.strFile = ''
        this.file = this.$refs.doc.files[0]
        if (!this.file) return

        const name = this.file.name.toLowerCase()
        const reader = new FileReader()

        if (name.endsWith('.csv')) {
          reader.onload = (res) => {
            this.content = res.target.result
            this.breakLines = this.content.includes('\r') ? 'r' : 'n'
            const lines =
              this.breakLines === 'r'
                ? this.content.split('\r\n')
                : this.content.split('\n')
            const delimitter = this.content.includes(';') ? ';' : ','
            const headers = lines[0].split(delimitter).map((h) => h.trim())

            if (headers[0] !== 'barcode' || headers[1] !== 'qty_op') {
              this.strFile =
                "Kolom file tidak sesuai. Header harus 'barcode' dan 'qty_op'."
              return
            }

            for (let i = 1; i < lines.length; i++) {
              if (!lines[i]) continue
              const currentline = lines[i].split(delimitter)
              if (currentline[0] === '') continue
              const barcode =
                currentline[0].charAt(0) === '#'
                  ? currentline[0].substring(1)
                  : currentline[0]
              this.csv_itemaddnew.push({
                barcode: barcode.trim(),
                qty_op: parseInt(currentline[1]) || 0,
                sku: '',
                name: '',
                item_id: 0,
                mark: 0,
              })
            }
            this.matchItemsFromMaster()
          }
          reader.readAsText(this.file)
        } else if (name.endsWith('.xls') || name.endsWith('.xlsx')) {
          readXlsxFile(this.file).then((rows) => {
            const headers = rows[0].map((h) => (h || '').toString().trim())
            if (headers[0] !== 'barcode' || headers[1] !== 'qty_op') {
              this.strFile =
                "Kolom file tidak sesuai. Header harus 'barcode' dan 'qty_op'."
              return
            }
            for (let i = 1; i < rows.length; i++) {
              const row = rows[i]
              if (!row[0]) continue
              this.csv_itemaddnew.push({
                barcode: row[0].toString().trim(),
                qty_op: parseInt(row[1]) || 0,
                sku: '',
                name: '',
                item_id: 0,
                mark: 0,
              })
            }
            this.matchItemsFromMaster()
          })
        } else {
          this.strFile = 'Format file tidak didukung. Gunakan .csv atau .xlsx'
        }
      },
      async matchItemsFromMaster() {
        // TODO: ganti dengan endpoint dedicated bulk-lookup-by-barcode saat backend siap.
        // Sementara memakai ItemService.getList (endpoint search yang sama dipakai autocomplete),
        // dicocokkan manual terhadap barcode_1.
        this.isLoadingImport = true
        for (const row of this.csv_itemaddnew) {
          try {
            const res = await this.itemService.getList(row.barcode)
            const found = (res.data || []).find(
              (it) => it.barcode_1 === row.barcode
            )
            if (found) {
              row.item_id = found.id
              row.sku = found.sku
              row.name = found.name
              row.ubox = found.ubox
              row.unit_s = found.unit_s
              row.unit_b = found.unit_b
              row.price = found.price
              row.mark = 0
            } else {
              row.mark = 1 // tidak ditemukan di master item
            }
          } catch (err) {
            row.mark = 1
          }
        }
        this.isLoadingImport = false
      },
      rowClassImport(data) {
        return data.mark === 1 ? 'bg-pink-100' : 'default-row'
      },
      onLoadCSV() {
        const notFound = this.csv_itemaddnew.filter((r) => r.mark === 1)
        if (notFound.length > 0) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Barcode',
            detail: `${notFound.length} barcode tidak ditemukan di master item dan akan dilewati.`,
            life: 4000,
          })
        }

        const supplier = this.selectedSupplierImport
        let added = 0
        let merged = 0

        // gabungkan dulu jika barcode yang sama muncul lebih dari sekali di file yang diimport
        const grouped = {}
        this.csv_itemaddnew
          .filter((r) => r.mark !== 1 && r.item_id > 0)
          .forEach((row) => {
            if (grouped[row.barcode]) {
              grouped[row.barcode].qty_op += row.qty_op || 0
            } else {
              grouped[row.barcode] = { ...row }
            }
          })

        Object.values(grouped).forEach((row) => {
          // cocokkan HANYA berdasarkan barcode, supplier diabaikan
          const idx = this.itemManuals.findIndex(
            (item) => item.barcode_1 === row.barcode
          )
          if (idx !== -1) {
            // barcode sudah ada di list -> jumlahkan qty
            const current = parseInt(this.itemManuals[idx].qty_label) || 0
            this.itemManuals[idx].qty_label = current + (row.qty_op || 0)            
            merged += 1
          } else {
            this.itemManuals.push({
              id: 0,
              item_id: row.item_id,
              sku: row.sku,
              barcode_1: row.barcode,
              description: row.name.substr(0, 50),
              ubox: row.ubox,
              unit_s: row.unit_s,
              unit_b: row.unit_b,
              supp_id: supplier ? supplier.id : null,
              supplier: supplier ? supplier.name : '',
              supp: supplier ? supplier.supp : '',
              price: row.price,
              qty_label: row.qty_op || 1,
            })
            added += 1
            this.showSupplierColumn = false
          }
        })

        this.$toast.add({
          severity: 'success',
          summary: 'Import Barcode',
          detail: `${added} item baru ditambahkan.${
            merged ? ' ' + merged + ' item duplikat, qty digabung.' : ''
          }`,
          life: 3000,
        })

        this.onCancel()
      },
      onCancel() {
        this.dialogImport = false
        this.csv_itemaddnew = []
        this.strFile = ''
        this.content = null
        this.selectedSupplierImport = null
      },
    },
  }
  </script>
  